import { useEffect, useState } from "react";

const ITEMS = [
  "🚀 BETA Launching 2026 — Get Early Access Now",
  "⭐ Licensees: Onboard Early & Lock In Reduced Commission — Limited Time",
  "💫 Now Closing Our First Round — We Don't Call Them Angels. We Call Them Fangels.",
  "🎯 Early Licensees Onboarding Now — Import Your Products & Be Ready For Launch",
  "🔥 eGeez BETA 2026 — The Licensed Marketplace Is Coming",
];

const SEPARATOR = " ✦ ";

export default function NewsTicker() {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    setDismissed(window.sessionStorage.getItem("egz_ticker_dismissed") === "1");
  }, []);

  if (dismissed) return null;

  const fullStripe = ITEMS.join(SEPARATOR) + SEPARATOR;

  return (
    <div
      className="relative w-full overflow-hidden text-white border-b border-white/10"
      style={{ background: "linear-gradient(90deg, #0033B8 0%, #0041E6 50%, #0033B8 100%)" }}
      role="region"
      aria-label="Site announcements"
      data-testid="news-ticker"
    >
      <div className="relative h-[34px] md:h-[36px] flex items-center">
        {/* edge fades */}
        <div
          className="absolute inset-y-0 left-0 w-12 z-10 pointer-events-none"
          style={{ background: "linear-gradient(to right, #0033B8, transparent)" }}
          aria-hidden
        />
        <div
          className="absolute inset-y-0 right-12 w-12 z-10 pointer-events-none"
          style={{ background: "linear-gradient(to left, #0033B8, transparent)" }}
          aria-hidden
        />

        <div className="ticker-track flex items-center whitespace-nowrap will-change-transform">
          {[0, 1].map((dup) => (
            <div
              key={dup}
              className="flex items-center text-[12px] md:text-[13px] tracking-[0.05em] font-bold pr-12 select-none"
              aria-hidden={dup === 1 ? true : undefined}
            >
              {fullStripe}
            </div>
          ))}
        </div>

        {/* close button */}
        <button
          type="button"
          aria-label="Dismiss announcements"
          data-testid="news-ticker-close"
          className="absolute top-1/2 -translate-y-1/2 right-2 md:right-3 z-20 inline-flex items-center justify-center w-6 h-6 rounded-full text-white/85 hover:text-white hover:bg-white/15 transition"
          onClick={() => {
            if (typeof window !== "undefined") {
              window.sessionStorage.setItem("egz_ticker_dismissed", "1");
            }
            setDismissed(true);
          }}
        >
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <style>{`
        @keyframes egz-ticker {
          from { transform: translate3d(0, 0, 0); }
          to   { transform: translate3d(-50%, 0, 0); }
        }
        .ticker-track {
          animation: egz-ticker 55s linear infinite;
        }
        @media (max-width: 640px) {
          .ticker-track { animation-duration: 35s; }
        }
        @media (prefers-reduced-motion: reduce) {
          .ticker-track { animation: none; }
        }
      `}</style>
    </div>
  );
}
